import { defineMessages } from 'react-intl'

export default defineMessages({
  fetchMore: {
    id: 'containers.NotificationsPage.fetchMore',
    defaultMessage: 'Fetch more',
  },
})